(() => {
  const PROXY_ENDPOINT = '/apps/preferiti';
 
  const customerId = window.ShopifyWishlist?.customerId || null;
  const loginRedirect = window.ShopifyWishlist?.loginRedirect || null;
  let items = window.ShopifyWishlist?.items || [];

  const sendToProxy = async (action, payload) => {
    const response = await fetch(PROXY_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        product_id: payload.id,
        action: action
      })
    });
    if (!response.ok) {
      throw new Error(`HTTP error. status: ${response.status}`);
    }
    
    const { items } = await response.json();
    return items;
  };

  const has = (productId) => {
    return items.some(item => String(item.id) === String(productId));
  }

  const add = async (payload) => {
    if (!has(payload.id)) {
      return await sendToProxy('add', payload);
    }
  };

  const remove = async (payload) => {
    if (has(payload.id)) {
      return await sendToProxy('remove', payload);
    }
  };

  const updateUI = (btn, label, updateItems = items) => {
    const id = btn.dataset.productId;
    const active = has(id);

    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active);
    btn.setAttribute(
      'aria-label',
      active ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti'
    );
    if (active) {
      if (label) label.textContent = 'Rimuovi dai preferiti';
        btn.setAttribute('aria-label', 'Rimuovi dai preferiti');
      } else {
        if (label) label.textContent = 'Aggiungi ai preferiti';
      btn.setAttribute('aria-label', 'Aggiungi ai preferiti');
    }
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-favorite-button]').forEach(btn => {
      const container = btn.closest('[data-favorite-container]');
      const label = container ? container.querySelector('[data-favorite-label]') : null;
      updateUI(btn, label);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    init();

    document.addEventListener('click', async (e) => {
      const container = e.target.closest('[data-favorite-container]');
      const btn = container.querySelector('[data-favorite-button');
      const label = container.querySelector('[data-favorite-label');
      if (!btn) return;

      const id = btn.dataset.productId;
      const handle = btn.dataset.productHandle;

      if (!customerId) {
        e.preventDefault();

        window.location.href = loginRedirect;
      }

      let updatedItems;

      if (has(id)) {
        updatedItems = await remove({ id, handle})
      }
      else {
        updatedItems = await add({ id, handle });
      }

      if (updatedItems) {
        items = updatedItems;
      }
      updateUI(btn, label, updatedItems);
    });
  });

})();
